export type SwipeDirection = 'left' | 'right' | 'vertical' | 'idle';

export interface ClassifySwipeArgs {
  dx: number;
  dy: number;
  threshold: number;
  directionLockRatio: number;
}

/** Pure classifier for 2D pointer deltas — no DOM, no React. */
export function classifySwipe({
  dx,
  dy,
  threshold,
  directionLockRatio,
}: ClassifySwipeArgs): SwipeDirection {
  const absDx = Math.abs(dx);
  const absDy = Math.abs(dy);

  // Vertical-dominant: guard native scroll. Check before threshold so even
  // short vertical starts are not misclassified as horizontal.
  if (absDy >= absDx * directionLockRatio) return 'vertical';

  // Below horizontal threshold → not yet a committed swipe.
  if (absDx < threshold) return 'idle';

  return dx < 0 ? 'left' : 'right';
}
